import { NgClass, NgStyle } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from 'primeng/api'
import { BlockUIModule } from 'primeng/blockui'
import { ButtonModule } from 'primeng/button'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { DividerModule } from 'primeng/divider'
import { DrawerModule } from 'primeng/drawer'
import { DialogService } from 'primeng/dynamicdialog'
import { InputNumberModule } from 'primeng/inputnumber'
import { InputTextModule } from 'primeng/inputtext'
import { ToolbarModule } from 'primeng/toolbar'

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer'

import { DocumentService } from '@app/services/document.service'
import { MetadataModule } from '@app/components/metadata/metadata.module'
import { GlobalErrorInterceptor } from '@app/interceptors/global-error.interceptor'

import { BlockableDivComponent } from './blockable-div.component'
import { DialogSplitComponent } from './dialog-split/dialog-split.component'
import { ViewerRoutingModule } from './viewer-routing.module'
import { ViewerComponent } from './viewer.component'

@NgModule({
  imports: [
    ViewerRoutingModule,
    FormsModule,
    SharedModule,
    ConfirmDialogModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    InputNumberModule,
    DrawerModule,
    BlockUIModule,
    ToolbarModule,
    MetadataModule,
    NgxExtendedPdfViewerModule,
    NgStyle,
    NgClass,
    ViewerComponent,
    DialogSplitComponent,
    BlockableDivComponent,
  ],
  providers: [
    DialogService,
    DocumentService,
    GlobalErrorInterceptor,
  ],
})
export class ViewerModule {}
